/**
 * @file SelectOptionColor
 */
'use strict'

/**
 * @classname SelectOptionColor
 * @classdesc 選択リストで「選択してください」の色を変える
 */
export default class SelectOptionColor {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('SelectOptionColor.constructor')
		this._$e = $e
		this._$e.css('color', '#AAAAAA')
		// if(this._$e.html() !== '選択してください'){
		// 	//this._$e.val('')
		// 	this._$e.prop('selectedIndex', -1);
		// }
		$e.on('change', () => this.onChange())

	}

	/**
	 * onChange
	 *
	 * @memberof SelectOptionColor
	 * @return {undefined}
	 */
	 onChange() {
		console.log('SelectOptionColor.onChange')
		if(this._$e.val() === '') {
			this._$e.css('color', '#AAAAAA');
		}else {
			this._$e.css('color', '#333333');
		}
	}
}
